import Api from '@/services';
import cookies from 'js-cookie';
import btnConfig from '@/utils/btn-config';
import Vue from 'vue';
import Router from 'vue-router';
const _import = require('../../router/_import_' + process.env.NODE_ENV);

function traverseTree(treeArray) {  
    // 遍历整个树形数组  
    for (let i = 0; i < treeArray.length; i++) {  
      const currentNode = treeArray[i];  
    
      // 遍历当前节点  


      currentNode.icon='el-icon-s-home'
      
  
      currentNode.showOnly=currentNode.extendData.showOnly
      currentNode.redirect=currentNode.extendData.redirect
      currentNode.hidden=currentNode.extendData.hidden
      currentNode.path=currentNode.extendData.path
      if(currentNode.extendData.routePath){
       // console.log("转换组件",currentNode.extendData.routePath,_import)
       try{
        currentNode.component=_import(currentNode.extendData.routePath)

       }catch(error){
            console.error("资源不存在",error)
       }
      //  console.log("转换后的组件",currentNode.component)
      }

      // 遍历子节点  
      if (currentNode.children && currentNode.children.length > 0) {  
        for (let j = 0; j < currentNode.children.length; j++) {  
          traverseTree(currentNode.children); // 递归遍历子节点数组  
        }  
      }  
    }  
  }  

const user = {
    state: {
        userName: '',
        realName: '',
        roles: [],
        loginStatus: false,
        groupType: null,
        btnCode: {},
        useInfo: {}
    },

    mutations: {
        SET_USER_INFO: (state, data) => {
            console.log('---设置userinfo----', data);
            if (data) {
                state.roles = data.roleList;
                state.useInfo = data.useInfo;
                state.userName = data.useInfo.userName;
                state.realName = data.useInfo.name;
                state.loginStatus = false;
                state.btnCode = data.btnCode;
            } else {
                state.roles = [];
                state.useInfo = {};
                state.userName = '';
                state.realName = '';
                state.loginStatus = true;
                state.btnCode = {};
            }

        },
    },

    actions: {
        // 获取用户信息
        GetInfo({ commit, dispatch }) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await Api.queryResource();
                    if (!response.success) {
                        commit('SET_USER_INFO');
                        reject(response);
                    } else {
                        let { data } = response;

                        console.log("-------------这是一个最原始的权限数据------------", data)

                        const btnCode = {}; // 按钮权限

                        traverseTree(data.treePermissionList)
                        data.roleList =   data.treePermissionList
                        // 页面权限
                      //  data.roleList = data.permissionList.map((item) => {
                        //    return item.code;
                        //})






                        //按钮权限
                        // (data.buttonList || []).forEach( (item) => {
                        //     btnConfig.forEach( (btnItem) => {
                        //         if (item.code == btnItem.code) {
                        //             btnCode[btnItem.key] = true;
                        //         }
                        //     })
                        // })
                        console.log("----------ddddd---SET_USER_INFO------------", data)

                        data.btnCode = btnCode; // 按钮权限
                        data.useInfo = data.sysUser; //用户信息
                        localStorage.setItem('btnCode', JSON.stringify(btnCode));
                        localStorage.setItem('userInfo', JSON.stringify(data.useInfo));
                        commit('SET_USER_INFO', data);
                        resolve(data);
                    }
                } catch (error) {
                    console.log("设置权限出错了",error)
                    commit('SET_USER_INFO');
                    reject(error);
                }
            });
        },

        // 前端 登出
        LogOut({ commit }) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await Api.logout()
                    if (response.success) {
                        commit('SET_USER_INFO');
                        resolve();
                    } else {
                        reject(error);
                    }
                } catch (error) {
                    console.error(error)
                    reject(error);
                }
            });
        },
        // login
        Login({ commit, dispatch }, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await Api.login(data)
                    if (response.success) {
                        localStorage.setItem('token', response.data.token);
                        const res = dispatch('GetInfo')
                        resolve(res);
                    } else {
                        reject(response);
                    }
                } catch (error) {
                    reject(error);
                }
            });
        },
    }

};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js